import Link from "next/link";
import React from "react";
import { MdClose } from "react-icons/md";

export default function ContactAlert(props) {
  const alertMessage = props.alertMessage;
  const alertStatus = props.alertStatus;
  const closeAlert = props.closeAlert;
  return (
    <div className="alert-wrapper">
      <div className="alert-content-wrapper">
        <div className="alert-header">
          <h4 className="alert-heading">{alertStatus || `Error`}</h4>
          <MdClose className="close-icon" onClick={() => closeAlert()} />
        </div>
        <div className="alert-message">
          <p>
            {`The following information was submitted and you will hear from a Tomcat representative soon.` ||
              `Hey you! Thank you for reaching out! If you are seeing this, something went wrong. Please contact us via phone.`}
          </p>
          <ul>
            <li><span className="label">Name:</span> {alertMessage?.name}</li>
            <li><span className="label">Email:</span> {alertMessage?.email}</li>
            <li><span className="label">Phone:</span> {alertMessage?.phone}</li>
            <li><span className="label">Comment:</span> {alertMessage?.comment}</li>
          </ul>
          <p>
            If this infomration is incorrect please reach out to us at <Link href="mailto:customerservice@rpscorporation.com">
              customerservice@rpscorporation.com
            </Link> or call us
            <Link href="tel:262-681-6470"> 262-681-6470</Link>.
          </p>
        </div>
      </div>
    </div >
  );
}
